import React, { Component } from 'react';
import './index.css';
import { Route, Redirect, Switch } from 'react-router';
import Menu from '../../components/Menu';

// Screens
import Conversations from './screens/Conversations';
import Help from './screens/Help';
import Settings from './screens/Settings';

class AdvisoryApp extends Component {

  render() {
    return (
      <div>
        <Menu />
        &nbsp;
        <Switch>
          <Redirect exact from={`${this.props.match.path}`} to={`${this.props.match.path}conversations`} />
          <Route path={`${this.props.match.path}conversations`} component={Conversations} />
          <Route path={`${this.props.match.path}help`} component={Help} />
          <Route path={`${this.props.match.path}settings`} component={Settings} />
        </Switch>
      </div>
    );
  }
}

export default AdvisoryApp;



// WEBPACK FOOTER //
// ./src/screens/AdvisoryApp/index.js